module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Silver Aluminum + Clementine Open.36bf954c.png";